<template>
    <v-switch v-model="isActive" v-bind="$attrs" @change="emit" />
</template>

<script>
export default {
    props: {
        value: { type: Array, default: () => [] }, // user.scope
        scopeValue: { type: String, default: null },
    },
    data: () => ({
        isActive: false,
    }),
    methods: {
        sync() {
            this.isActive = (this.value || []).includes(this.scopeValue);
        },
        emit() {
            let [...scope] = this.value || [];
            const hasScope = scope.includes(this.scopeValue);
            if (this.isActive) {
                if (!hasScope) scope.push(this.scopeValue);
            } else {
                if (hasScope) scope.splice(scope.indexOf(this.scopeValue), 1);
            }

            this.$emit("input", scope);
            this.$emit("change", scope);
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
};
</script>

<style>
</style>